import * as React from 'react';
import { PreviewMode } from '../preview-elements/preview-context';
import { composer } from '../../../component-decorators/composer';
import { TextButton } from 'wix-style-react';
export var DevelopedByWrapper = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return value.isPreview && !props.name ? (React.createElement(TextButton, { as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info", target: "_blank" }, props.t('solution.page.preview.developedByPlaceHolder'))) : (props.children);
    }));
});
//# sourceMappingURL=developedby-wrapper.js.map